import Paragraph from "../components/paragraph/Paragraph";
import Button from "../components/button/Button";
import { ReactComponent as WelcomeIlustration } from "../assets/images/welcome-ilustration.svg";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../constants/routes";

const SelectPlan = () => {
  const navigate = useNavigate();

  return (
    <div className="select-plan">
      <div className="select-plan_card">
        <WelcomeIlustration className="hover-float" />
        <div className="select-plan_content">
          <h2 className="section-title">Odaberi plan</h2>
          <Paragraph variant="p2" className="text-muted select-plan_subtitle">
            Dva načina plaćanja - biraš ono što ti odgovara.
          </Paragraph>

          <div className="select-plan_options">
            <div className="select-plan_option">
              <span className="select-plan_option-tag">Jednokratno</span>
              <div className="select-plan_price">
                <Paragraph variant="title">Već od</Paragraph>
                <div>
                  <span className="select-plan_amount">19€</span>
                  <Paragraph variant="p2" className="select_plan_paragraph">
                    za mesec dana
                  </Paragraph>
                </div>
              </div>
              <Paragraph
                variant="p2"
                className="text-muted select-plan_option-note"
              >
                Plati jednom, bez automatskog obnavljanja.
              </Paragraph>
            </div>
            <div className="select-plan_option">
              <span className="select-plan_option-tag">Pretplata</span>
              <div className="select-plan_price">
                <Paragraph variant="title">Već od</Paragraph>
                <div>
                  <span className="select-plan_amount">19€</span>
                  <Paragraph variant="p2" className="select_plan_paragraph">
                    / mesečno
                  </Paragraph>
                </div>
              </div>
              <Paragraph
                variant="p2"
                className="text-muted select-plan_option-note"
              >
                Automatsko obnavljanje, otkaži bilo kada.
              </Paragraph>
            </div>
          </div>

          <Button
            variant="primary"
            onClick={() => navigate(ROUTES.subscription)}
            label="Pronađi odgovarajući plan"
          />
        </div>
      </div>
    </div>
  );
};

export default SelectPlan;
